import { DateTime } from "luxon"
import { TimelineCalendarEvent, TimelineCalendarEventTimeRange } from "../calendar/fullCalendarTypes"
import { EventDropArg } from "@fullcalendar/core"
import { EventResizeDoneArg } from "@fullcalendar/interaction"
import { DeliveryWithCart } from "../../form/formTypes"
import { EventsForServiceCenterResponse } from "../../../createOrderApi"

export const LOCAL_EVENT = "local-"
const LOCAL_EVENT_COLOR = "#93C5FD"
export const DEFAULT_DURATION_MINUTES = 30
export const isLocalEvent = (id: string) => id?.startsWith(LOCAL_EVENT)
export const isCanEditExistOrder = (info: EventDropArg | EventResizeDoneArg) => !!info.event?.extendedProps["canEdit"]

export const createNewEvent = (
    resourceId: string,
    start: string,
    end: string,
    timeRange?: TimelineCalendarEventTimeRange,
): TimelineCalendarEvent => ({
    id: `${LOCAL_EVENT}${resourceId}-${start}`,
    resourceIds: [resourceId],
    start,
    end,
    backgroundColor: LOCAL_EVENT_COLOR,
    timeRange,
})

export const createInitEvents = (resourceIds: string[], start: string, end: string): TimelineCalendarEvent => {
    const firstResourceId = resourceIds[0] || "book-period"

    return {
        id: `${LOCAL_EVENT}${firstResourceId}-${start}`,
        resourceIds,
        start,
        end,
        backgroundColor: LOCAL_EVENT_COLOR,
    }
}

export function roundDateTimeToNearestMinutes(dateTime: DateTime, nearestMinutes: number): DateTime {
    const rounded = Math.ceil(dateTime.minute / nearestMinutes) * nearestMinutes
    return dateTime.set({ minute: rounded, second: 0, millisecond: 0 })
}

export function earliestTime(times: DeliveryWithCart[]): string {
    return times.map((t) => t.time!).sort((a, b) => a.localeCompare(b))[0]
}

export const splitIntoThreeDays = (startStr: string, endStr: string) => {
    const start = DateTime.fromISO(startStr)
    const hardEnd = DateTime.fromISO(endStr)
    // Build [day0, day1, day2], each clamped to fetchInfo.endStr (exclusive)
    return [0, 1, 2].map((i) => {
        const s = start.plus({ days: i })
        const e = s.plus({ days: 1 })
        const endClamped = DateTime.min(e, hardEnd)
        return { startISO: s.toISO(), endISO: endClamped.toISO()! }
    })
}

export const mergeUniqueEvents = (parts: EventsForServiceCenterResponse[]) => {
    const map = new Map<number, NonNullable<EventsForServiceCenterResponse["events"]>[number]>()
    for (const res of parts) {
        for (const ev of res?.events ?? []) {
            if (!map.has(ev.orderId)) map.set(ev.orderId, ev)
        }
    }
    return Array.from(map.values())
}
